import { createGlobalStyle } from 'styled-components';
import Inter from '../fonts/Inter.ttf';
import Roboto from '../fonts/Roboto-Regular.ttf';

const GlobalStyles = createGlobalStyle`
/*
    @font-face {
        font-family: 'Inter';
        src: local('Inter'), url(${Inter}) format('truetype');
    }
    @font-face {
        font-family: 'Roboto';
        src: local('Roboto'), url(${Roboto}) format('truetype');
    }
*/
    body {

    }

    @media screen and (max-width: 500px) {
        body {
            font-size: 0.8rem;
        }
    }

    .App {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
            'Droid Sans', 'Helvetica Neue', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    @media screen and (max-width: 500px) {
        .MuiStepLabel-label {
            font-size: 13px !important;
        }

        .nav-link {
            padding: 4px;
        }
        
    }

    #page-wrap {
        text-align: center;
    }

    .btn-link, a {
        color: ${(props) => props.theme.link.color};

        &:hover,
        &:focus {
            color: ${(props) => props.theme.link.colorHover};
            text-decoration: underline;
        }
    }

    .form-control {
        border-color: ${(props) => props.theme.input.border};

        &:focus {
            border-color: ${(props) => props.theme.input.borderFocus};
            box-shadow: ${(props) => props.theme.input.boxShadowFocus};
        }
    }

    .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        margin: -1px;
        padding: 0;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        border: 0;
        white-space: nowrap; /* Prevents line breaks from affecting layout */
    }


    .tooltip .tooltip-inner {
        color: black;
        background-color: #D8D9DA;
    }

    .dropdown-item {
        &:hover {
            background-color:  ${(props) => props.theme.selectButton.backgroundColorHover};
        }
        &:active {
            background-color: ${(props) => props.theme.combobox.optionBackgroundActive};
            color: black
        },

    }
    .dropdown-menu {
        box-shadow: ${(props) => props.theme.combobox.boxShadowFocus};
    }
    
`;

export default GlobalStyles;
